import * as React from 'react';
import * as _ from 'lodash';
import { NavigatorContainer as Navigator } from '../../components/Navigator';
import { PARTS } from './../../schemas/accessRightsModel';
import { cleanProps } from '../../utilities/props';
export default function (props, context) {
    function onClick1() {
        props.exitEditQuote(props.page, props.term);
    }
    return React.createElement('div', _.assign({}, cleanProps(props)), props.AR.v(PARTS.FOOTER_ACTIONS) ? React.createElement(Navigator, {
        'hideHomeButton': 'true',
        'key': '321'
    }) : null, React.createElement('div', { 'className': 'lightbox-button-block' }, props.editableQuote ? React.createElement('div', {
        'className': 'lightbox-save-button',
        'onClick': onClick1.bind(this),
        'key': '443'
    }, 'RETURN TO JOB BOARD') : null));
}